type SkipParams = {
	isFridgeIdValid: boolean;
	hasValidFridge: boolean;
	isUnauthorized: boolean;
	isConflict: boolean;
	hasStarted: boolean;
};

/**
 * Skip is a LATCHED STARTUP GATE, not a runtime teardown switch. Once the subscription has started,
 * only a hard, persistent reason skips it: invalid id, UNAUTHORIZED (prompts for a new UUID), or
 * CONFLICT (the fridge has no active sales point, so the backend rejects every subscription attempt).
 * A transient fridge.error from a reconnect refetch must NOT tear down a running subscription.
 */
export const resolveShouldSkipSubscription = ({
	isFridgeIdValid,
	hasValidFridge,
	isUnauthorized,
	isConflict,
	hasStarted,
}: SkipParams): boolean => {
	if (!isFridgeIdValid || isUnauthorized || isConflict) {
		return true;
	}
	if (hasStarted) {
		return false;
	}
	return !hasValidFridge;
};

/**
 * With the latch in place, a runtime skip-flip `false→true` AFTER the subscription has started should
 * only ever be a hard reason (invalid id / UNAUTHORIZED / CONFLICT) — never the transient fridge.error
 * that used to strand the stream (root cause #1). It's worth a Sentry line so we can confirm in the field
 * that the latch closed that hole (and catch any new path that re-opens it).
 */
export const shouldLogSkipFlip = (hasStarted: boolean, prevSkip: boolean, nextSkip: boolean): boolean =>
	hasStarted && !prevSkip && nextSkip;
